// extracted by mini-css-extract-plugin
export default {"logo":"header_logo-module__logo--3nkO8","logoNotLogged":"header_logo-module__logoNotLogged--3c1Bk"};